/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createQuickReorder = /* GraphQL */ `
  mutation CreateQuickReorder(
    $input: CreateQuickReorderInput!
    $condition: ModelQuickReorderConditionInput
  ) {
    createQuickReorder(input: $input, condition: $condition) {
      id
      user_id
      product_id
      stock
      variant
      last_order
      brand_id
      category_id
      created_at
      updated_at
      seller_id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateQuickReorder = /* GraphQL */ `
  mutation UpdateQuickReorder(
    $input: UpdateQuickReorderInput!
    $condition: ModelQuickReorderConditionInput
  ) {
    updateQuickReorder(input: $input, condition: $condition) {
      id
      user_id
      product_id
      stock
      variant
      last_order
      brand_id
      category_id
      created_at
      updated_at
      seller_id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteQuickReorder = /* GraphQL */ `
  mutation DeleteQuickReorder(
    $input: DeleteQuickReorderInput!
    $condition: ModelQuickReorderConditionInput
  ) {
    deleteQuickReorder(input: $input, condition: $condition) {
      id
      user_id
      product_id
      stock
      variant
      last_order
      brand_id
      category_id
      created_at
      updated_at
      seller_id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createOrders = /* GraphQL */ `
  mutation CreateOrders(
    $input: CreateOrdersInput!
    $condition: ModelOrdersConditionInput
  ) {
    createOrders(input: $input, condition: $condition) {
      id
      user_id
      product_id
      seller_id
      quantity
      status
      variant
      shipping_address
      created_at
      updated_at
      brand_id
      category_id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOrders = /* GraphQL */ `
  mutation UpdateOrders(
    $input: UpdateOrdersInput!
    $condition: ModelOrdersConditionInput
  ) {
    updateOrders(input: $input, condition: $condition) {
      id
      user_id
      product_id
      seller_id
      quantity
      status
      variant
      shipping_address
      created_at
      updated_at
      brand_id
      category_id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOrders = /* GraphQL */ `
  mutation DeleteOrders(
    $input: DeleteOrdersInput!
    $condition: ModelOrdersConditionInput
  ) {
    deleteOrders(input: $input, condition: $condition) {
      id
      user_id
      product_id
      seller_id
      quantity
      status
      variant
      shipping_address
      created_at
      updated_at
      brand_id
      category_id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSellerInfo = /* GraphQL */ `
  mutation CreateSellerInfo(
    $input: CreateSellerInfoInput!
    $condition: ModelSellerInfoConditionInput
  ) {
    createSellerInfo(input: $input, condition: $condition) {
      id
      user_id
      business_name
      description
      phone
      street
      suite
      city
      state
      country
      postal_code
      tax_id
      tax_documents
      is_verified
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSellerInfo = /* GraphQL */ `
  mutation UpdateSellerInfo(
    $input: UpdateSellerInfoInput!
    $condition: ModelSellerInfoConditionInput
  ) {
    updateSellerInfo(input: $input, condition: $condition) {
      id
      user_id
      business_name
      description
      phone
      street
      suite
      city
      state
      country
      postal_code
      tax_id
      tax_documents
      is_verified
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSellerInfo = /* GraphQL */ `
  mutation DeleteSellerInfo(
    $input: DeleteSellerInfoInput!
    $condition: ModelSellerInfoConditionInput
  ) {
    deleteSellerInfo(input: $input, condition: $condition) {
      id
      user_id
      business_name
      description
      phone
      street
      suite
      city
      state
      country
      postal_code
      tax_id
      tax_documents
      is_verified
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createVariantAttribute = /* GraphQL */ `
  mutation CreateVariantAttribute(
    $input: CreateVariantAttributeInput!
    $condition: ModelVariantAttributeConditionInput
  ) {
    createVariantAttribute(input: $input, condition: $condition) {
      id
      name
      created_by
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateVariantAttribute = /* GraphQL */ `
  mutation UpdateVariantAttribute(
    $input: UpdateVariantAttributeInput!
    $condition: ModelVariantAttributeConditionInput
  ) {
    updateVariantAttribute(input: $input, condition: $condition) {
      id
      name
      created_by
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteVariantAttribute = /* GraphQL */ `
  mutation DeleteVariantAttribute(
    $input: DeleteVariantAttributeInput!
    $condition: ModelVariantAttributeConditionInput
  ) {
    deleteVariantAttribute(input: $input, condition: $condition) {
      id
      name
      created_by
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCategories = /* GraphQL */ `
  mutation CreateCategories(
    $input: CreateCategoriesInput!
    $condition: ModelCategoriesConditionInput
  ) {
    createCategories(input: $input, condition: $condition) {
      id
      name
      description
      image
      is_active
      is_deleted
      updated_by
      deleted_by
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCategories = /* GraphQL */ `
  mutation UpdateCategories(
    $input: UpdateCategoriesInput!
    $condition: ModelCategoriesConditionInput
  ) {
    updateCategories(input: $input, condition: $condition) {
      id
      name
      description
      image
      is_active
      is_deleted
      updated_by
      deleted_by
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCategories = /* GraphQL */ `
  mutation DeleteCategories(
    $input: DeleteCategoriesInput!
    $condition: ModelCategoriesConditionInput
  ) {
    deleteCategories(input: $input, condition: $condition) {
      id
      name
      description
      image
      is_active
      is_deleted
      updated_by
      deleted_by
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createBrands = /* GraphQL */ `
  mutation CreateBrands(
    $input: CreateBrandsInput!
    $condition: ModelBrandsConditionInput
  ) {
    createBrands(input: $input, condition: $condition) {
      id
      name
      description
      image
      is_active
      is_deleted
      updated_by
      deleted_by
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateBrands = /* GraphQL */ `
  mutation UpdateBrands(
    $input: UpdateBrandsInput!
    $condition: ModelBrandsConditionInput
  ) {
    updateBrands(input: $input, condition: $condition) {
      id
      name
      description
      image
      is_active
      is_deleted
      updated_by
      deleted_by
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteBrands = /* GraphQL */ `
  mutation DeleteBrands(
    $input: DeleteBrandsInput!
    $condition: ModelBrandsConditionInput
  ) {
    deleteBrands(input: $input, condition: $condition) {
      id
      name
      description
      image
      is_active
      is_deleted
      updated_by
      deleted_by
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProductInfo = /* GraphQL */ `
  mutation CreateProductInfo(
    $input: CreateProductInfoInput!
    $condition: ModelProductInfoConditionInput
  ) {
    createProductInfo(input: $input, condition: $condition) {
      id
      brand_id
      category_id
      is_active
      is_deleted
      updated_by
      deleted_by
      created_at
      updated_at
      seller_id
      variants
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProductInfo = /* GraphQL */ `
  mutation UpdateProductInfo(
    $input: UpdateProductInfoInput!
    $condition: ModelProductInfoConditionInput
  ) {
    updateProductInfo(input: $input, condition: $condition) {
      id
      brand_id
      category_id
      is_active
      is_deleted
      updated_by
      deleted_by
      created_at
      updated_at
      seller_id
      variants
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProductInfo = /* GraphQL */ `
  mutation DeleteProductInfo(
    $input: DeleteProductInfoInput!
    $condition: ModelProductInfoConditionInput
  ) {
    deleteProductInfo(input: $input, condition: $condition) {
      id
      brand_id
      category_id
      is_active
      is_deleted
      updated_by
      deleted_by
      created_at
      updated_at
      seller_id
      variants
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserInfo = /* GraphQL */ `
  mutation CreateUserInfo(
    $input: CreateUserInfoInput!
    $condition: ModelUserInfoConditionInput
  ) {
    createUserInfo(input: $input, condition: $condition) {
      id
      user_id
      first_name
      last_name
      email
      has_roles
      current_role
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserInfo = /* GraphQL */ `
  mutation UpdateUserInfo(
    $input: UpdateUserInfoInput!
    $condition: ModelUserInfoConditionInput
  ) {
    updateUserInfo(input: $input, condition: $condition) {
      id
      user_id
      first_name
      last_name
      email
      has_roles
      current_role
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserInfo = /* GraphQL */ `
  mutation DeleteUserInfo(
    $input: DeleteUserInfoInput!
    $condition: ModelUserInfoConditionInput
  ) {
    deleteUserInfo(input: $input, condition: $condition) {
      id
      user_id
      first_name
      last_name
      email
      has_roles
      current_role
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createStylistInfo = /* GraphQL */ `
  mutation CreateStylistInfo(
    $input: CreateStylistInfoInput!
    $condition: ModelStylistInfoConditionInput
  ) {
    createStylistInfo(input: $input, condition: $condition) {
      id
      user_id
      saloon_name
      phone
      street
      suite
      city
      state
      country
      postal_code
      is_verified
      license_path
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateStylistInfo = /* GraphQL */ `
  mutation UpdateStylistInfo(
    $input: UpdateStylistInfoInput!
    $condition: ModelStylistInfoConditionInput
  ) {
    updateStylistInfo(input: $input, condition: $condition) {
      id
      user_id
      saloon_name
      phone
      street
      suite
      city
      state
      country
      postal_code
      is_verified
      license_path
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteStylistInfo = /* GraphQL */ `
  mutation DeleteStylistInfo(
    $input: DeleteStylistInfoInput!
    $condition: ModelStylistInfoConditionInput
  ) {
    deleteStylistInfo(input: $input, condition: $condition) {
      id
      user_id
      saloon_name
      phone
      street
      suite
      city
      state
      country
      postal_code
      is_verified
      license_path
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserShippingAddress = /* GraphQL */ `
  mutation CreateUserShippingAddress(
    $input: CreateUserShippingAddressInput!
    $condition: ModelUserShippingAddressConditionInput
  ) {
    createUserShippingAddress(input: $input, condition: $condition) {
      id
      user_id
      shipping_address
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserShippingAddress = /* GraphQL */ `
  mutation UpdateUserShippingAddress(
    $input: UpdateUserShippingAddressInput!
    $condition: ModelUserShippingAddressConditionInput
  ) {
    updateUserShippingAddress(input: $input, condition: $condition) {
      id
      user_id
      shipping_address
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserShippingAddress = /* GraphQL */ `
  mutation DeleteUserShippingAddress(
    $input: DeleteUserShippingAddressInput!
    $condition: ModelUserShippingAddressConditionInput
  ) {
    deleteUserShippingAddress(input: $input, condition: $condition) {
      id
      user_id
      shipping_address
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserBilling = /* GraphQL */ `
  mutation CreateUserBilling(
    $input: CreateUserBillingInput!
    $condition: ModelUserBillingConditionInput
  ) {
    createUserBilling(input: $input, condition: $condition) {
      id
      user_id
      customer_id
      payment_id
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserBilling = /* GraphQL */ `
  mutation UpdateUserBilling(
    $input: UpdateUserBillingInput!
    $condition: ModelUserBillingConditionInput
  ) {
    updateUserBilling(input: $input, condition: $condition) {
      id
      user_id
      customer_id
      payment_id
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserBilling = /* GraphQL */ `
  mutation DeleteUserBilling(
    $input: DeleteUserBillingInput!
    $condition: ModelUserBillingConditionInput
  ) {
    deleteUserBilling(input: $input, condition: $condition) {
      id
      user_id
      customer_id
      payment_id
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCartItems = /* GraphQL */ `
  mutation CreateCartItems(
    $input: CreateCartItemsInput!
    $condition: ModelCartItemsConditionInput
  ) {
    createCartItems(input: $input, condition: $condition) {
      id
      user_id
      product_id
      quantity
      variant
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCartItems = /* GraphQL */ `
  mutation UpdateCartItems(
    $input: UpdateCartItemsInput!
    $condition: ModelCartItemsConditionInput
  ) {
    updateCartItems(input: $input, condition: $condition) {
      id
      user_id
      product_id
      quantity
      variant
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCartItems = /* GraphQL */ `
  mutation DeleteCartItems(
    $input: DeleteCartItemsInput!
    $condition: ModelCartItemsConditionInput
  ) {
    deleteCartItems(input: $input, condition: $condition) {
      id
      user_id
      product_id
      quantity
      variant
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSellerPaymentInfo = /* GraphQL */ `
  mutation CreateSellerPaymentInfo(
    $input: CreateSellerPaymentInfoInput!
    $condition: ModelSellerPaymentInfoConditionInput
  ) {
    createSellerPaymentInfo(input: $input, condition: $condition) {
      id
      seller_id
      account_holder_name
      bank_name
      routing_number
      account_number
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSellerPaymentInfo = /* GraphQL */ `
  mutation UpdateSellerPaymentInfo(
    $input: UpdateSellerPaymentInfoInput!
    $condition: ModelSellerPaymentInfoConditionInput
  ) {
    updateSellerPaymentInfo(input: $input, condition: $condition) {
      id
      seller_id
      account_holder_name
      bank_name
      routing_number
      account_number
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSellerPaymentInfo = /* GraphQL */ `
  mutation DeleteSellerPaymentInfo(
    $input: DeleteSellerPaymentInfoInput!
    $condition: ModelSellerPaymentInfoConditionInput
  ) {
    deleteSellerPaymentInfo(input: $input, condition: $condition) {
      id
      seller_id
      account_holder_name
      bank_name
      routing_number
      account_number
      created_at
      updated_at
      createdAt
      updatedAt
      __typename
    }
  }
`;
